import type { AvatarWithIconT, TimeLineAvatarDataT } from 'components/Timeline/types'
import { TimelineAvatarTypeT } from 'components/Timeline/types'

export const getIsAvatarWithIcon = (avatar: TimeLineAvatarDataT): avatar is AvatarWithIconT =>
  avatar.type === TimelineAvatarTypeT.icon
